import React, { Component } from 'react'
import Tick from '../assets/images/tick-white.svg'

class Timeline extends Component {

  render() {

    let { title, blocks } = this.props

    return (
      <section className='timeline'>
        <div className='timeline__inner'>
          <h2 className='timeline__title' dangerouslySetInnerHTML={{ __html: title }} />
          { blocks && 
            <div className='timeline__items'>
              {blocks.map((el, i) => (
                <div className='timeline__item' key={i}>
                  <div className='curved-line' />
                  <div className='timeline__content'>
                    <h4 dangerouslySetInnerHTML={{ __html: el.title }} />
                    { el.list && 
                      <ul>
                        {el.list.map((li, l) => (
                          <li key={l}>
                            <span className='timeline__tick'>
                              <img src={Tick} alt='Kollosche - Timeline' />
                            </span>
                            <span className='timeline__list-item'>{li.text}</span>
                          </li>
                        ))}
                      </ul>
                    }
                  </div>
                  <div className='timeline__year'>
                    <span>{el.year}</span>
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </section>
    )
  }
}

export default Timeline
